import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ typographyPresets }: Theme) => ({
    pass: {
        padding: '12px',
        marginBottom: '16px',
        border: 'solid 1px #979797',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    bottom: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {
        ...typographyPresets.titleSmallBold,
    },
    dateAndCode: {
        ...typographyPresets.labelPrimary,
        color: '#979797',
        alignSelf: 'center',
    },
    '@media (max-width: 767px)': {
        header: {
            flexDirection: 'column',
            marginBottom: 10,
        },
        pass: {
            '& > $bottom': {
                flexDirection: 'column',
            },
        },
        dateAndCode: {
            alignSelf: 'flex-start',
        },
    },
}))
